import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "w-full px-4 py-2 mb-5 overflow-hidden text-gray-500 truncate border border-gray-300 whitespace-nowrap dark:bg-gray-600 dark:border-gray-900 dark:text-gray-300" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.share_link_dialog')
};
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import ModalDialog from '@/components/ModalDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ShareLinkDialog',
    setup(__props) {
        const route = useRoute();
        const link = computed(() => window.location.origin + route.fullPath);
        const showModal = ref(true);
        const hideModal = () => {
            showModal.value = false;
        };
        const copyAndClose = () => {
            navigator.clipboard.writeText(link.value);
            hideModal();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalDialog, {
                class: "max-w-150",
                centered: "",
                "secondary-actions": {
                    [_ctx.$t('cancel')]: hideModal
                },
                "primary-actions": {
                    [_ctx.$t('confirm')]: copyAndClose
                },
                "dismiss-action": hideModal,
                show: showModal.value
            }, {
                before: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('before')), 1)
                ]),
                heading: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('heading')), 1)
                ]),
                after: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(link)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('after')), 1)
                ]),
                _: 1
            }, 8, ["secondary-actions", "primary-actions", "show"]));
        };
    }
});
